<template>
	<div>
		<!-- ################################################## -->
		<!-- default -->
		<!-- ################################################## -->
		<template v-if="variant === 'default'">
			<!-- Overlay -->
			<Transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut faster">
				<div
					v-if="isOverlayVisible"
					class="s-fixed s-top-0 s-left-0 s-w-full s-h-screen"
					:style="`background-color:rgba(0,0,0,0.6); ${zIndex ? `z-index: ${zIndex}` : ''};`"
					v-scroll-lock="true"
				></div>
			</Transition>

			<!-- Modal -->
			<Transition enter-active-class="animated zoomIn fastest" leave-active-class="animated zoomOut faster">
				<JFlex
					v-if="isModalVisible"
					class="s-w-full s-items-center s-justify-center s-bg-transparent s-fixed s-top-0 s-left-0 s-h-screen s-overflow-y-auto s-p-8"
					@click.self="$emit('overlay:click')"
					:style="zIndex ? `z-index: ${zIndex}` : ''"
				>
					<div class="s-w-full s-max-w-3xl s-bg-white s-m-auto s-rounded-lg  s-overflow-hide s-shadow-lg">
						<slot></slot>
					</div>
				</JFlex>
			</Transition>
		</template>

		<!-- ################################################## -->
		<!-- default-large -->
		<!-- ################################################## -->
		<template v-if="variant === 'default-large' || variant === 'default-lg'">
			<!-- Overlay -->
			<Transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut faster">
				<div
					v-if="isOverlayVisible"
					class="s-fixed s-top-0 s-left-0 s-w-full s-h-screen"
					:style="`background-color:rgba(0,0,0,0.75); ${zIndex ? `z-index: ${zIndex}` : ''};`"
					v-scroll-lock="true"
				></div>
			</Transition>

			<!-- Modal -->
			<Transition enter-active-class="animated zoomIn fastest" leave-active-class="animated zoomOut faster">
				<div
					v-if="isModalVisible"
					class="s-w-full s-bg-transparent s-fixed s-top-0 s-left-0 s-h-screen s-overflow-y-auto s-p-8"
					@click.self="$emit('overlay:click')"
					:style="zIndex ? `z-index: ${zIndex + 1}` : ''"
				>
					<div class="s-w-full s-bg-white s-m-auto s-rounded-lg s-overflow-hidden s-shadow-lg">
						<slot></slot>
					</div>
				</div>
			</Transition>
		</template>

		<!-- ################################################## -->
		<!-- default-small -->
		<!-- ################################################## -->
		<template v-if="variant === 'default-small' || variant === 'default-sm'">
			<!-- Overlay -->
			<Transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut faster">
				<div
					v-if="isOverlayVisible"
					class="s-fixed s-top-0 s-left-0 s-w-full s-h-screen"
					:style="`background-color:rgba(0,0,0,0.6); ${zIndex ? `z-index: ${zIndex}` : ''};`"
					v-scroll-lock="true"
				></div>
			</Transition>

			<!-- Modal -->
			<Transition enter-active-class="animated zoomIn fastest" leave-active-class="animated zoomOut faster">
				<JFlex
					v-if="isModalVisible"
					class="s-w-full s-items-center s-justify-center s-bg-transparent s-fixed s-top-0 s-left-0 s-h-screen s-overflow-y-auto s-p-8"
					@click.self="$emit('overlay:click')"
					:style="zIndex ? `z-index: ${zIndex}` : ''"
				>
					<div class="s-w-4/12 s-bg-white s-m-auto s-rounded-lg  s-overflow-hide s-shadow-lg" style="min-width: 25rem">
						<slot></slot>
					</div>
				</JFlex>
			</Transition>
		</template>

		<!-- ################################################## -->
		<!-- default-smallest -->
		<!-- ################################################## -->
		<template v-if="variant === 'default-smallest' || variant === 'default-xs'">
			<!-- Overlay -->
			<Transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut faster">
				<div
					v-if="isOverlayVisible"
					class="s-fixed s-top-0 s-left-0 s-w-full s-h-screen"
					:style="`background-color:rgba(0,0,0,0.6); ${zIndex ? `z-index: ${zIndex}` : ''};`"
					v-scroll-lock="true"
				></div>
			</Transition>

			<!-- Modal -->
			<Transition enter-active-class="animated zoomIn fastest" leave-active-class="animated zoomOut faster">
				<JFlex
					v-if="isModalVisible"
					class="s-w-full s-items-center s-justify-center s-bg-transparent s-fixed s-top-0 s-left-0 s-h-screen s-overflow-y-auto s-p-8"
					@click.self="$emit('overlay:click')"
					:style="zIndex ? `z-index: ${zIndex}` : ''"
				>
					<div class="s-w-3/12 s-bg-white s-m-auto s-rounded-lg  s-overflow-hide s-shadow-lg" style="min-width: 18rem">
						<slot></slot>
					</div>
				</JFlex>
			</Transition>
		</template>

		<!-- ################################################## -->
		<!-- side -->
		<!-- ################################################## -->
		<template v-if="variant === 'side'">
			<!-- Overlay -->
			<Transition enter-active-class="animated fadeIn fastest" leave-active-class="animated fadeOut faster">
				<div
					v-if="isOverlayVisible"
					class="s-fixed s-top-0 s-left-0 s-w-full s-h-screen"
					:style="`background-color:rgba(0,0,0,0.6); ${zIndex ? `z-index: ${zIndex}` : ''};`"
					v-scroll-lock="true"
				></div>
			</Transition>

			<!-- Modal -->
			<Transition enter-active-class="animated fadeInRight fastest" leave-active-class="animated fadeOut faster">
				<JFlex
					v-if="isModalVisible"
					class="s-w-full s-items-center s-justify-end s-bg-transparent s-fixed s-top-0 s-left-0 s-h-screen"
					@click.self="$emit('overlay:click')"
					:style="zIndex ? `z-index: ${zIndex}` : ''"
				>
					<div class="s-w-full s-h-full s-max-w-2xl s-bg-white s-overflow-y-auto">
						<slot></slot>
					</div>
				</JFlex>
			</Transition>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: () => "default"
		},

		isVisible: {
			type: Boolean,
			default: false
		},

		zIndex: {
			type: String,
			default: ""
		}
	},

	computed: {
		isOverlayVisible() {
			return this.isVisible
		},

		isModalVisible() {
			return this.isOverlayVisible
		}
	}
}
</script>
